import api from "../../_core/api";
import { AuthConfig } from "./types";
import { PasswordPolicy } from "../types";

export const doesHubUserExist = async () => {
  try {
    const response = await api({
      method: "GET",
      url: "/users/my/exists",
    });

    return response.status === 204;
  } catch (error) {
    return false;
  }
};

export const getAuthConfig = async () => {
  const { data }: { data: AuthConfig } = await api({
    method: "GET",
    url: "/auth-config/partner-portal",
    is_hub: true,
    skip_bearer_injection: true,
    skip_token_refresh: true,
  });

  if (!data?.tokenIssuerUrl || !data?.partnerPortalClientId) {
    throw Error(`Missing some of the mandatory attributes in the returned data: ${data}`);
  }

  return data;
};

export const getUserpoolPasswordPolicy = async (userpoolId: string) => {
  const { data }: { data: PasswordPolicy } = await api({
    method: "GET",
    url: `/auth-config/password-policies/cognito-user-pools/${userpoolId}`,
    is_hub: true,
    skip_bearer_injection: true,
    skip_token_refresh: true,
  });

  return data;
};

export const migrateSsoUser = async (email: string, password?: string) => {
  const { data }: { data: string } = await api({
    method: "POST",
    url: "/users/migrate",
    skip_bearer_injection: true,
    skip_token_refresh: true,
    is_hub: true,
    data: {
      email,
      password,
    },
  });
  return data;
};
